module.exports = __webpack_public_path__ + "img/burger.7cce40ea.svg";